import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import DataProvider from '../../../app/data-framework/data-provider';
import FilterManager from '../../../app/helpers/filter-manager';
import FilterFormatter from '../../../app/data-formatters/filter-formatter';
import PermissionService from '../../../services/permission.service';
import QueryCommon from '../../../app/helpers/query-common';
import templateMarkup from 'raw-loader!./flexipanel-options.html';
import LoginService from "../../../services/login.service";

const selectDatasetMessage = '(select data source)';
const selectCategoryMessage = '(select category)';
const selectMetricMessage = '(select metric)';
const selectEndpointCategory = '(select endpoint category)';
const selectSortOrderMessage = '(select sort order)';
const selectHoursPerDay = '(select hours per day)';
const selectDaysPerWeek = '(select days per week)';

function FlexiPanelOptions(params) {
    var self = this;

    self.filterFormatter = new FilterFormatter();
    self.queryCommon = new QueryCommon();

    self.params = params.widgetParams;
    self.observableOptions = self.params.observableOptions;

    var options = self.observableOptions();

    self.parentWidgetSignals = params.widgetSignals; // parent widget's signals (used to signal events to parent)
    self.genericFilterSignals = {}; // to get event signals from the genericfilters-widget
    self.id = params.id;
    self.validationMessage = ko.observable(null);
    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);
    self.currentModule = self.dataProvider.getCurrentModule();
    self.visibilityOptions = ko.observable({});
    self.metadata = self.dataProvider.getFlexPanelMetaDataObservable();

    self.panelTemplate = self.params.panelTemplate;

    self.columnOptionsObs = ko.observableArray();
    self.endpointModelsObs = ko.observableArray();
    self.systemsObs = ko.observableArray();

    self.observableData = params.observableData;

    self.hoursperday = 8;
    self.daysperweek = 7;
    self.hoursPattern = '^(2[0-4]|[01]?[0-9])$';
    self.daysPattern = '^([1-7])$';

    self.loadMode = true;

    self.panelHeader = ko.observable(options.panelHeader || self.panelTemplate.header);
    self.type = options.type;

    self.selectedDisplayType = ko.observable();
    self.metricColumns = ko.observableArray();
    self.groupColumns = ko.observableArray();
    self.selectedGroupColumn = ko.observable();

    self.aggregations = ko.observableArray(['Sum', 'Avg', 'Count']);
    self.selectedAggregation = ko.observable('Sum');

    self.timegrains = ko.observableArray(['day', 'week', 'month', 'quarter']);
    self.selectedTimeGrain = ko.observable('day');

    self.categories = ko.observableArray();
    // TODO: Do these need to be retrieved from the DB instead of hardcoded?
    self.epcategories = ko.observableArray(['Immersive', 'Group', 'Personal', 'Software', 'Phone', 'Others']);
    self.vmrcategories = ko.observableArray();

    self.sortorder = ko.observableArray(['Top', 'Bottom']);

    self.selectedEPCategory = ko.observable(_.get(options, 'selectedEPCategory', 'Group'));
    self.selectedVMRCategory = ko.observable(_.get(options, 'selectedVMRCategory', 'MCU'));

    self.selectedSortOrder = ko.observable(_.get(options, 'selectedSortOrder', 'Bottom'));

    self.datasets = ko.observableArray();
    self.selectedDataset = ko.observable();

    self.selectedCategory = ko.observable(_.get(options, 'defaultCategory'));

    self.categoriesVisible = ko.observable(!isTable(options));
    self.displayTypeVisible = ko.observable(!self.isKpiWidget() && !isTable(options));

    self.hideFilters = ko.observable((isTable(options) && !options.panelFilters));
    self.metricsVisible = ko.observable(!isTable(options));

    var endpointModels = self.dataProvider.getEndpointModelsObservable();
    var systems = self.dataProvider.getSystemsObservable();

    self.groupsVisible = ko.observable(!isTable(options) && !self.isKpiWidget());
    self.timeGrainVisible = ko.observable(options.type === 'Trend');
    self.datasetsVisible = ko.observable(isTable(options));
    self.selectedHoursPerDay = ko.observable(_.get(options, 'selectedHoursPerDay', self.hoursperday));
    self.selectedDaysPerWeek = ko.observable(_.get(options, 'selectedHoursPerDay', self.daysperweek));
    self.selectedCount = 10;

    self.hoursVisible = ko.observable(self.isHoursVisible());
    self.epCategoriesVisible = ko.observable(ko.unwrap(self.selectedDataset) === 'manageendpointdeltaxml' && !options.panelFilters);
    self.vmrCategoriesVisible = ko.observable(ko.unwrap(self.selectedDataset) === 'vmrdeltaxml');
    self.sortVisible = ko.observable(self.isSortVisible());

    self.filterGroups = ko.observableArray();
    self.groupFilters = ko.observableArray();

    self.selectedMetricColumn = ko.observable();

    self.displayTypesTrend = ['Area Trend', 'Stacked Area Trend', 'Bar Trend', 'Line Trend', 'Table'];
    self.displayTypesDist = ['Pie', 'Bar', 'Table'];
    self.displayTypesSum = ['Table'];

    self.displayTypes = ko.observableArray(self.getDisplayTypesByChartType(self.type));

    self.selectedDisplayType = ko.observable('Table');

    self.flexQueryViewLevelOptions = ko.observable({
        WhereConditionObj: [],
        WhereConditionConjunction: 'and'
    });

    self.setupSubscriptions();

    if (endpointModels && ko.isObservable(endpointModels)) {
        self.endpointModelsObs = endpointModels;
    }

    if (systems && ko.isObservable(systems)) {
        self.systemsObs = systems;
    }

    var metadatasub = null;
    if (!_.isEmpty(ko.unwrap(self.metadata))) {
        self.setupOptions();
    } else {
        metadatasub = self.metadata.subscribe(function () {
            self.setupOptions();
            metadatasub.dispose();
        });
    }

    self.parentWidgetSignals.optionsPanelOpen.add(function () {
        self.loadMode = true;
        self.loadOptions();

        var savedHeader = _.get(ko.unwrap(self.params.observableOptions), 'panelHeader');
        var defaultHeader = _.get(self, 'params.panelTemplate.header');

        self.panelHeader(savedHeader || defaultHeader);
    });

    self.selectedMetricColumn.subscribe(function(column) {
        self.hoursVisible(self.isHoursVisible());
    });

    self.allowApply = ko.pureComputed(function() {
        let hasErrors = false;
        let dataset = ko.unwrap(self.selectedDataset);
        let category = ko.unwrap(self.selectedCategory);
        let metrics = ko.unwrap(self.selectedMetricColumn);
        let selectedSortOrder = ko.unwrap(self.selectedSortOrder);
        let hoursPerDay = ko.unwrap(self.selectedHoursPerDay);
        let daysPerWeek = ko.unwrap(self.selectedDaysPerWeek);
        let selectedEPCategory = ko.unwrap(self.selectedEPCategory);
        let selectedVMRCategory = ko.unwrap(self.selectedVMRCategory);
        if (!self.panelHeader()) {
            hasErrors = true;
        }
        if (self.datasetsVisible() && (!dataset || dataset === selectDatasetMessage)) {
            hasErrors = true;
        }
        if (self.categoriesVisible() && (!category || category === selectCategoryMessage)) {
            hasErrors = true;
        }
        if (self.metricsVisible() && (!metrics || metrics === selectMetricMessage)) {
            hasErrors = true;
        }
        if (self.sortVisible() && (!selectedSortOrder || selectedSortOrder === selectSortOrderMessage)) {
            hasErrors = true;
        }
        if (self.hoursVisible() && (!hoursPerDay || hoursPerDay === selectHoursPerDay)) {
            hasErrors = true;
        }
        if (self.hoursVisible() && (!daysPerWeek || daysPerWeek === selectDaysPerWeek)) {
            hasErrors = true;
        }
        if (self.epCategoriesVisible() && (!selectedEPCategory || selectedEPCategory === '(select endpoint category)')) {
            hasErrors = true;
        }
        if (self.vmrCategoriesVisible() && (!selectedVMRCategory || selectedVMRCategory === '(select system type)')) {
            hasErrors = true;
        }
        return !hasErrors;
    });
}

FlexiPanelOptions.prototype = {
    setupSubscriptions: function() {
        var self = this;
        self.subscriptions = [
            self.selectedCategory.subscribe(function (newCategory) {
                if (!newCategory || newCategory === selectCategoryMessage) {
                    self.selectedMetricColumn(selectMetricMessage);
                } else {
                    let metrics = _.filter(self.allMetricColumns, ['categoryKey', newCategory]);
                    if (metrics.indexOf(self.selecetedMetricColumn) < 0) {
                        self.selectedMetricColumn(selectMetricMessage);
                    }
                }
                self.selectedGroupColumn(null);
                self.setFiltersVisibility(newCategory);
                self.setMetricsByCategory(newCategory);
            }),

            self.selectedMetricColumn.subscribe(function (newMetric) {
                if (newMetric === selectMetricMessage) {
                    return;
                }
                self.setFiltersVisibility(self.selectedCategory, newMetric);
                self.setAggregation();
                self.fillGroups();
                self.setPanelHeader();
                // reset filters because they're different between columns
                self.flexQueryViewLevelOptions({
                    WhereConditionObj: [],
                    WhereConditionConjunction: 'and'
                });
            }),

            self.selectedDataset.subscribe(function (dataset) {
                if (self.loadMode) {
                    return;
                }
                if (!_.isEmpty(dataset)) {
                    self.loadDatasetFilterOptions(dataset);
                }
                // reset filters because dataset changed
                self.flexQueryViewLevelOptions({
                    WhereConditionObj: [],
                    WhereConditionConjunction: 'and'
                });
                self.hoursVisible(self.isHoursVisible());
                self.setEPCategoriesVisible();
                self.setVMRCategoriesVisible();
                self.setSortVisible();
                self.setPanelHeader();
            }),

            self.selectedEPCategory.subscribe(function () {
                if (self.loadMode) {
                    return;
                }
                self.setPanelHeader();
            }),

            self.selectedVMRCategory.subscribe(function () {
                if (self.loadMode) {
                    return;
                }
                self.setPanelHeader();
            }),

            self.selectedSortOrder.subscribe(function () {
                if (self.loadMode) {
                    return;
                }
                self.setPanelHeader();
            }),

            self.selectedGroupColumn.subscribe(self.setPanelHeader.bind(self)),
        ];
    },

    filterAppliedConditions: function(whereCondition, whereConditionConjunction) {
        var self = this;
        var conditions = whereCondition[0].conditions;
        let columns = ko.unwrap(self.metricColumns);

        // return if not loaded or we will clear out all filters
        if (_.isEmpty(columns)) {
          return;
        }

        whereCondition[0].conditions = conditions.filter(function (condition) {
            var filterItem = _.find(self.allFilters, ['columnKey', condition.selectedLhs]);

            if (!filterItem) {
                return;
            }

            // We need to get valid filters for all the metrics available for the selected categoty.
            var categoryMetricsColumnPrefixes = _.map(columns, function (metric) {
                return getColumnKeyPrefix(metric.columnKey);
            });

            var validFilters = _.filter(self.allFilters, function (filter) {
                // we want all filters with column key prefixes that match the metric's prefix
                return _.includes(categoryMetricsColumnPrefixes, getColumnKeyPrefix(filter.factKey));
            });

            return _.includes(_.map(validFilters, 'columnKey'), filterItem.columnKey);
        });

        self.flexQueryViewLevelOptions({
            WhereConditionObj: whereCondition,
            WhereConditionConjunction: whereConditionConjunction
        });
    },

    setFiltersVisibility: function(category, metric) {
        var self = this;
        // TODO: This should be data driven. GetFlexQueryMetaData should include
        var HideFiltersCategoryMap = {
            models: ['capacity', 'meeting', 'scheduleroom', 'system'],
            systems: ['call', 'endpoint', 'manageendpoint', 'activeendpoint', 'scheduleroom']
        };

        ////////////////////////////////////////////////////////
        // We need to hide filter dropdown for Summary panel. //
        ////////////////////////////////////////////////////////
        var options = ko.unwrap(self.observableOptions);
        var isSummaryPanel = isTable(options) && options.panelFilters;

        self.visibilityOptions({
            hideModels: (_.includes(HideFiltersCategoryMap.models, category) || isSummaryPanel),
            hideSystems: self.currentModule !== 'AdvancedAnalytics'
                         || (_.includes(HideFiltersCategoryMap.systems, category) || isSummaryPanel)
                         || (metric && metric.toLowerCase().indexOf('trunk') > -1)
        });

        if (!category || isSummaryPanel) {
            return;
        }

        if (!_.isEmpty(options.whereConditionObj)) {
            self.filterAppliedConditions(options.whereConditionObj, options.whereConditionConjunction, HideFiltersCategoryMap);
        }
    },

    saveOptions: function () {
        var self = this;
        var currentOptions = self.params.observableOptions();

        var newOptions = {
            selectedCategory: self.selectedCategory(),
            selectedMetricColumnNames: [self.selectedMetricColumn() || ''],
            selectedGroupColumnNames: [self.selectedGroupColumn() || ''],
            selectedAggregations: [self.selectedAggregation() || ''],
            selectedDisplayType: self.selectedDisplayType(),
            selectedTimeGrain: self.selectedTimeGrain(),
            selectedDatasetNames: [self.selectedDataset() || ''],
            whereConditionObj: self.flexQueryViewLevelOptions().WhereConditionObj,
            whereConditionConjunction: self.flexQueryViewLevelOptions().WhereConditionConjunction,
            panelHeader: self.panelHeader(),
            selectedHoursPerDay: self.selectedHoursPerDay(),
            selectedDaysPerWeek: self.selectedDaysPerWeek(),
            selectedEPCategory: self.selectedEPCategory(),
            selectedVMRCategory: self.selectedVMRCategory(),
            selectedSortOrder: ko.unwrap(self.selectedSortOrder) === 'Top' ? 'ASC' : 'DESC',
            selectedCount: 10
        };

        if (areOptionsDifferent(currentOptions, newOptions)) {
            deleteOptionSpecificValues(currentOptions);
            var updatedOptions = _.assign({}, currentOptions, newOptions);
            self.params.observableOptions(updatedOptions);
        }
    },

    loadOptions: function () {
        var self = this;
        var options = self.observableOptions();
        self.type = options.type;

        self.displayTypes(self.getDisplayTypesByChartType(self.type));

        self.selectedCategory(options.selectedCategory);
        let categorySelect = document.getElementById('cmbCategory' + self.id);
        if (categorySelect) {
            if (options.selectedCategory && !options.selectedCategory.startsWith('(')) {
                let selectOptions = categorySelect.options;
                for (var opt, j = 0; opt = selectOptions[j]; j++) {
                    if (opt.value == options.selectedCategory) {
                        categorySelect.selectedIndex = j;
                        break;
                    }
                }
            } else {
                categorySelect.selectedIndex = 0;
            }
        }
        if (options.selectedCategory && options.selectedCategory === self.selectedCategory()) {
            self.setMetricsByCategory(options.selectedCategory);
            self.setFiltersVisibility(self.selectedCategory());
        }

        if (!_.isEmpty(options.selectedMetricColumnNames)) {
            if (_.isEmpty(ko.unwrap(self.selectedCategory))) {
                self.selectedCategory(self.getMetricCategory(_.first(options.selectedMetricColumnNames)));
            }
            self.selectedMetricColumn(_.first(options.selectedMetricColumnNames));
        }

        if (!_.isEmpty(options.selectedGroupColumnNames)) {
            let selectedGroup = _.toLower(_.first(options.selectedGroupColumnNames));
            self.selectedGroupColumn(selectedGroup);
            let groupSelect = document.getElementById('cmbGroup' + self.id);
            if (groupSelect) {
                if (selectedGroup && !selectedGroup.startsWith('(')) {
                    let selectOptions = groupSelect.options;
                    for (var opt, j = 0; opt = selectOptions[j]; j++) {
                        if (opt.value == selectedGroup) {
                            groupSelect.selectedIndex = j;
                            break;
                        }
                    }
                } else {
                    groupSelect.selectedIndex = 0;
                }
            }
        }

        if (!_.isEmpty(_.get(options, 'selectedAggregations'))) {
            self.selectedAggregation(_.first(options.selectedAggregations));
        }

        self.setAggregation(); //if metric has aggregatefunction, use that instead of saved.

        if (options.selectedDisplayType) {
            self.selectedDisplayType(options.selectedDisplayType);
        }

        if (options.selectedTimeGrain) {
            self.selectedTimeGrain(options.selectedTimeGrain);
        }

        if (isTable(options)) {
            self.datasetsVisible(true);
            if (_.isEmpty(_.get(options, 'selectedDatasetNames'))) {
                self.selectedDataset([]);
                self.setFiltersVisibility();
            } else {
                var selectedDataset = _.first(options.selectedDatasetNames);
                self.selectedDataset(selectedDataset);
                self.loadDatasetFilterOptions(selectedDataset);
                self.setVMRCategoriesVisible();
                self.setSortVisible();

                let datasetSelect = document.getElementById('cmbDataSource' + self.id);
                if (datasetSelect) {
                    if (selectedDataset && !selectedDataset.startsWith('(')) {
                        let selectOptions = datasetSelect.options;
                        for (var opt, j = 0; opt = selectOptions[j]; j++) {
                            if (opt.value == selectedDataset) {
                                datasetSelect.selectedIndex = j;
                                break;
                            }
                        }
                    } else {
                        datasetSelect.selectedIndex = 0;
                    }
                }
            }
        }

        if (options.whereConditionObj && options.whereConditionConjunction) {
            self.flexQueryViewLevelOptions({
              WhereConditionObj: options.whereConditionObj,
              WhereConditionConjunction: options.whereConditionConjunction
            });
        } else {
          // fall back for old panels
          if (options.whereConditionObj) {
              let conjunction = options.whereConditionObj.WhereConditionConjunction || 'AND';
              self.flexQueryViewLevelOptions({
                WhereConditionObj: options.whereConditionObj,
                WhereConditionConjunction: options.whereConditionConjunction
              });
          } else if (options.viewLevelOptions) {
            let vlo = ko.unwrap(options.viewLevelOptions);
            let parsedConditions = self.queryCommon.parseConditionsFromString(vlo.WhereCondition);
            self.flexQueryViewLevelOptions({
              WhereConditionObj: parsedConditions.flexQueryWhereConditionObj,
              WhereConditionConjunction: vlo.whereConditionConjunction
            });
          } else {
            self.flexQueryViewLevelOptions({WhereConditionObj: [], WhereConditionConjunction: 'and'});
          }
        }

        if (options.selectedHoursPerDay) {
            self.selectedHoursPerDay(options.selectedHoursPerDay);
        }

        if (options.selectedDaysPerWeek) {
            self.selectedDaysPerWeek(options.selectedDaysPerWeek);
        }

        if (options.selectedEPCategory) {
            self.selectedEPCategory(options.selectedEPCategory);
        }

        if (options.selectedVMRCategory) {
            let selectedVMRCategory = options.selectedVMRCategory;
            self.selectedVMRCategory(selectedVMRCategory);
            let vmrSelect = document.getElementById('cmbVmrCategory' + self.id);
            if (vmrSelect) {
                if (selectedVMRCategory && !selectedVMRCategory.startsWith('(')) {
                    let selectOptions = vmrSelect.options;
                    for (var opt, j = 0; opt = selectOptions[j]; j++) {
                        if (opt.value == selectedVMRCategory) {
                            vmrSelect.selectedIndex = j;
                            break;
                        }
                    }
                } else {
                    vmrSelect.selectedIndex = 0;
                }
            }
        }

        if (options.selectedSortOrder) {
            var sortOrder = options.selectedSortOrder === 'ASC' ? 'Top' : 'Bottom';
            self.selectedSortOrder(sortOrder);
            let sortSelect = document.getElementById('cmbSortOrder' + self.id);
            if (sortSelect) {
                if (sortOrder && !sortOrder.startsWith('(')) {
                    let selectOptions = sortSelect.options;
                    for (var opt, j = 0; opt = selectOptions[j]; j++) {
                        if (opt.value == sortOrder) {
                            sortSelect.selectedIndex = j;
                            break;
                        }
                    }
                } else {
                    sortSelect.selectedIndex = 0;
                }
            }
        }

        self.hoursVisible(self.isHoursVisible());
        if (self.hoursVisible) {
          let selectedHoursPerDay = options.selectedHoursPerDay;
          let selectedDaysPerWeek = options.selectedDaysPerWeek;
          let hoursSelect = document.getElementById('txtHoursPerDay' + self.id);
          if (hoursSelect) {
              if (selectedHoursPerDay && !selectedHoursPerDay.startsWith('(')) {
                  let selectOptions = hoursSelect.options;
                  for (var opt, j = 0; opt = selectOptions[j]; j++) {
                      if (opt.value == selectedHoursPerDay) {
                          hoursSelect.selectedIndex = j;
                          break;
                      }
                  }
              } else {
                  hoursSelect.selectedIndex = 0;
              }
          }
          let daysSelect = document.getElementById('txtDaysPerWeek' + self.id);
          if (daysSelect) {
              if (selectedDaysPerWeek && !selectedDaysPerWeek.startsWith('(')) {
                  let selectOptions = daysSelect.options;
                  for (var opt, j = 0; opt = selectOptions[j]; j++) {
                      if (opt.value == selectedDaysPerWeek) {
                          daysSelect.selectedIndex = j;
                          break;
                      }
                  }
              } else {
                  daysSelect.selectedIndex = 0;
              }
          }
        }
        self.setEPCategoriesVisible();
        self.setVMRCategoriesVisible();
        self.sortVisible(self.isSortVisible());

        self.selectedCount = 10;
        self.loadMode = false;
    },

    getSelectedMetric: function() {
        var self = this;
        var metric = ko.unwrap(self.selectedMetricColumn);

        if (!metric) {
            return null;
        }

        var allmetrics = ko.unwrap(self.metricColumns);
        return _.find(allmetrics, ['columnKey', metric]);
    },

    setAggregation: function () {
        var self = this;
        var selectedMetric = self.getSelectedMetric();

        if (selectedMetric && selectedMetric.aggregateFunction) {
            self.selectedAggregation(selectedMetric.aggregateFunction);
        }
    },

    fillGroups: function () {
        var self = this;
        if (ko.unwrap(self.selectedMetricColumn) && self.allGroups) {
            var metricPrefix = getColumnKeyPrefix(ko.unwrap(self.selectedMetricColumn));

            var groups = _.filter(self.allGroups, function (grp) {
                // we want all groups with column key prefixes that match the metric's prefix
                return getColumnKeyPrefix(grp.factKey) === metricPrefix;
            });

            groups.unshift({
                columnKey: '',
                columnName: '',
                columnDescription: '(no grouping)',
                columnDescriptionBy: '(no grouping)'
            });

            var groupkeys = _.map(groups, 'columnKey');

            if (!_.includes(ko.unwrap(self.selectedGroupColumn), groupkeys)) {
                self.selectedGroupColumn('');
            }

            self.groupColumns(groups);

            var filters = _.filter(self.allFilters, function (filter) {
                // we want all filters with column key prefixes that match the metric's prefix
                return getColumnKeyPrefix(filter.factKey) === metricPrefix;
            });

            var filtergroups = getFilterGroups(filters);

            self.filterGroups(filtergroups.groups);
            self.groupFilters(filtergroups.filters);

            var coloptions = _.map(filters, self.filterFormatter.filterToTypeaheadCondition);

            self.columnOptionsObs(coloptions);

            // now that groups are updated, make sure correct one is selected
            let selectedGroup = self.selectedGroupColumn();
            let groupSelect = document.getElementById('cmbGroup' + self.id);
            if (groupSelect) {
                if (selectedGroup && !selectedGroup.startsWith('(')) {
                    let selectOptions = groupSelect.options;
                    for (var opt, j = 0; opt = selectOptions[j]; j++) {
                        if (opt.value == selectedGroup) {
                            groupSelect.selectedIndex = j;
                            break;
                        }
                    }
                } else {
                    groupSelect.selectedIndex = 0;
                }
            }
        }
    },

    loadDatasets: function() {
        var self = this;
        var metaDatasets = _.get(ko.unwrap(self.metadata), 'Datasets');
        var datasets =_.chain(metaDatasets)
            .filter(function (dataset) {
              if (dataset.panelFlag !== 1) {
                  return false;
              }
              return filterByAppContext(dataset, self.currentModule, self.dataProvider);
            })
            .map(function(dataset) {
                return {
                    title: dataset.datasetName,
                    value: dataset.datasetKey
                };
            }).value();

        self.datasets(datasets);
    },

    loadCategories: function(allMetrics) {
        var self = this;
        self.categories(getCategoriesWithMetrics(allMetrics, _.get(ko.unwrap(self.metadata), 'Categories'), self.currentModule, self.dataProvider));
    },

    setupOptions: function() {
        var self = this;
        var options = self.observableOptions();
        var meta = _.get(ko.unwrap(self.metadata), 'Table');

        self.allMetricColumns = _.filter(meta, function(metric) {
            if (metric.otherFlag !== 1) {
              return false;
            }
            return filterByAppContext(metric, self.currentModule, self.dataProvider);
        });

        self.loadDatasets();
        self.loadCategories(self.allMetricColumns);

        if (!_.isEmpty(ko.unwrap(self.selectedCategory))) {
            self.setMetricsByCategory(self.selectedCategory());
        } else {
            self.metricColumns(self.allMetricColumns);
        }

        self.allFilters = _.assign([], _.chain(self.metadata())
          .get('FilterCols')
          .filter(col => filterByAppContext(col, self.currentModule, self.dataProvider))
          .value());

        self.allGroups = _.assign([], _.chain(self.metadata())
          .get('GroupCols')
          .filter(col => filterByAppContext(col, self.currentModule, self.dataProvider))
          .value());

        _.forEach(self.allGroups, function(grp) {
            grp.columnDescriptionBy = 'by ' + capitalize(grp.columnDescription);
        });

        self.loadOptions();
        self.fillGroups();

        if (!_.isEmpty(options.selectedGroupColumnNames)) {
            self.selectedGroupColumn(_.toLower(_.first(options.selectedGroupColumnNames)));
        }
    },

    resetOptions: function () {
        var self = this;
        var defaultDisplayType = self.displayTypes()[0];
        var defaultTimeGrain = self.timegrains()[0];

        self.panelHeader(self.panelTemplate.header);
        self.selectedCategory('');
        self.selectedMetricColumn('');
        self.selectedGroupColumn([]);
        self.selectedDisplayType(defaultDisplayType);
        self.selectedTimeGrain(defaultTimeGrain);
        self.selectedAggregation('');
        self.selectedDataset('');
        self.flexQueryViewLevelOptions({
            WhereConditionObj: [],
            WhereConditionConjunction: 'and'
        });

        let panelHeaderEl = document.getElementById('txtPanelTitle' + self.id);
        if (panelHeaderEl) {
            panelHeaderEl.value = self.panelTemplate.header;
        }
        let categorySelect = document.getElementById('cmbCategory' + self.id);
        if (categorySelect) {
            categorySelect.selectedIndex = 0;
        }
        let metricSelect = document.getElementById('cmbMetric' + self.id);
        if (metricSelect) {
            metricSelect.selectedIndex = 0;
        }
        let dataSelect = document.getElementById('cmbDataSource' + self.id);
        if (dataSelect) {
            dataSelect.selectedIndex = 0;
        }
    },

    loadDatasetFilterOptions: function(dataset) {
        var self = this;
        return self.dataProvider.loadFiltersForKey(dataset).then(function(filters) {
            if (_.isEmpty(filters)) {
                return;
            }
            self.columnOptionsObs(_.map(filters, self.filterFormatter.filterToTypeaheadCondition));
            self.setFiltersVisibility(dataset);
        });
    },

    getMetricCategory: function(metric) {
        var self = this;
        return _.chain(_.get(ko.unwrap(self.metadata), 'Table'))
            .find(['columnKey', metric])
            .get('categoryKey')
            .value();
    },

    setMetricsByCategory: function(category) {
        let self = this;
        let type = self.type;
        if (!self.allMetricColumns) {
            return;
        }
        if (!category || category === 'all') {
            return self.metricColumns(self.allMetricColumns);
        }
        var metrics = _.filter(self.allMetricColumns, ['categoryKey', category]);
        // limit by type flag
        switch (type) {
            case 'Pie':
                metrics = metrics.filter((metric) => metric.dashboardDistributionFlag);
                break;

            case 'Trend':
                metrics = metrics.filter((metric) => metric.dashboardTrendFlag);
                break;

            default:
                break;
        }
        if (metrics && metrics.length > 0 && metrics.indexOf(self.selectedMetricColumn()) < 0) {
            self.selectedMetricColumn('');
        }
        self.metricColumns(metrics);
    },

    setEPCategoriesVisible: function() {
        var self = this;
        self.epCategoriesVisible(
            ko.unwrap(self.selectedDataset) === 'manageendpointdeltaxml' &&
            _.get(!ko.unwrap(self.observableOptions), 'panelFilters')
        );
    },

    setSortVisible: function() {
        var self = this;
        var selectedDataset = self.selectedDataset();
        self.sortVisible(selectedDataset === 'manageendpointdeltaxml' || selectedDataset === 'vmrdeltaxml');
    },

    setVMRCategoriesVisible: function() {
        var self = this;
        if (self.selectedDataset() === 'vmrdeltaxml') {
            self.vmrCategoriesVisible(true);
            self.dataProvider.loadSystems('vmr').then(function (systems) {
                self.vmrcategories(_.chain(systems).map('dimsystem.systemtype').uniq().value());
            });
        } else {
            self.vmrCategoriesVisible(false);
        }
    },

    isHoursVisible: function() {
        var self = this;
        var dataset = ko.unwrap(self.selectedDataset);
        var metric = self.getSelectedMetric();
        return (dataset === 'manageendpointsubcategoryxml' ||
            dataset === 'managedendpointsubcategoryxml' ||
            (metric && metric.hoursConfigFlag));
    },

    isSortVisible: function() {
        var self = this;
        return (ko.unwrap(self.selectedDataset) === 'manageendpointdeltaxml' || ko.unwrap(self.selectedDataset) === 'vmrdeltaxml');
    },

    isKpiWidget: function() {
        var self = this;
        return _.get(ko.unwrap(self.params.observableOptions), 'type') === 'kpipanel-widget';
    },

    getDisplayTypesByChartType: function(type) {
        var self = this;
        var displayTypes;

        switch (type) {
            case 'Pie':
                displayTypes = self.displayTypesDist;
                break;

            case 'Trend':
                displayTypes = self.displayTypesTrend;
                break;

            default:
                displayTypes = self.displayTypesSum;
                break;
        }
        return displayTypes;
    },

    setPanelHeader: function() {
        var self = this;
        var datasetName = ko.unwrap(self.selectedDataset);
        var epCategory = ko.unwrap(self.selectedEPCategory);
        var vmrCategory = ko.unwrap(self.selectedVMRCategory);
        var sortOrder = ko.unwrap(self.selectedSortOrder);

        var metricname = getName(
            ko.unwrap(self.metricColumns),
            ko.unwrap(self.selectedMetricColumn),
            'columnKey',
            'columnDescription'
        );
        var groupname = getName(
            ko.unwrap(self.groupColumns),
            ko.unwrap(self.selectedGroupColumn),
            'columnKey',
            'columnDescription'
        );
        var name;
        if (datasetName) {
            switch (datasetName) {
                case 'callqualityxml':
                    self.panelHeader('Call Quality Summary');
                    break;

                case 'managedendpointsubcategoryxml':
                case 'manageendpointsubcategoryxml':
                    self.panelHeader('Managed Endpoint Summary');
                    break;

                case 'manageendpointdeltaxml':
                    name = sortOrder + ' Managed Endpoint Summary';
                    if (epCategory && epCategory !== selectEndpointCategory) {
                        name += ' - ' + epCategory;
                    }
                    self.panelHeader(name);
                    break;

                case 'participantqualityxml':
                    self.panelHeader('Participant Quality Summary');
                    break;

                case 'systemtypexml':
                    self.panelHeader('Infrastructure Summary');
                    break;

                case 'vmrdeltaxml':
                    name = sortOrder + 'VMR Summary';
                    if (vmrCategory) {
                        name += ' - ' + vmrCategory;
                    }
                    self.panelHeader(name);
                    break;

                default:
                    self.panelHeader('Summary');
            }
        } else if (metricname) {
            if (groupname && (groupname !== '(no grouping)')) {
                self.panelHeader(metricname + ' by ' + groupname);

            } else {
                self.panelHeader(metricname);
            }
        }
    },

    onApply: function(data, event) {
        var self = this;
        if (!self.allowApply()) {
            return event.stopPropogation();
        }
        self.saveOptions();
        self.resetOptions();
        self.parentWidgetSignals.optionsPanelApply.dispatch();
    },

    onCancel: function() {
        var self = this;
        self.resetOptions();
        self.parentWidgetSignals.optionsPanelClose.dispatch();
    },

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose: function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    }
};

/** Helper Functions **/
function areOptionsDifferent(sourceOptions, newOptions) {
    var different = false;
    _.forOwn(newOptions, function (value, key) {
        if (!_.isEqual(_.get(sourceOptions, key), value)) {
            different = true;
            return false; // exit early
        }
    });
    return different;
}

function capitalize(str) {
    return _.isEmpty(str) ? '' : str.charAt(0).toUpperCase() + str.slice(1);
}

function deleteOptionSpecificValues(options) {
    delete options.displayDetail;
    delete options.display;
}

function getUniqueCategoriesMap(metrics) {
    var metricCategoriesMap = {};
    _.forEach(metrics, function (metric) {
        metricCategoriesMap[metric.categoryKey] = true;
    });
    return metricCategoriesMap;
}

// filter helper function that returns false if the passed in metadata should
// be filtered out because it doesn't match the current module
function filterByAppContext(metadata, currentModule, dataProvider) {
    if (metadata.appContext) {
        if (currentModule === 'AdvancedAnalytics') {
            let appContexts = metadata.appContext.split(',');
            let areAnyContextsInModules = _.reduce(appContexts, isInModulesOrPreviousValueWas, false);
            return areAnyContextsInModules; // only filter if none in modules
        } else {
            return metadata.appContext.includes(currentModule);
        }
    }
    return true;

    function isInModulesOrPreviousValueWas(previousMatch, appContext) {
        // short circuit because we only need one match
        return previousMatch || LoginService.userObject.isInModules(appContext);
    }
}

function getCategoriesWithMetrics(metrics, categories, currentModule, dataProvider) {
    var metricCategoriesMap = getUniqueCategoriesMap(metrics);
    return _.filter(categories, function (category) {
        return (category.categoryKey === 'all' || metricCategoriesMap[category.categoryKey])
          && filterByAppContext(category, currentModule, dataProvider);
    });
}

function getFilterGroups(filterColumns) {
    var groupFilters = [];
    var parents = [];

    filterColumns.forEach(function (fcitem) {
        if (fcitem.columnDistinctValueCount > 0) {
            var values = fcitem.columnDistinctValue.split(',');

            values.forEach(function (valitem) {
                groupFilters.push({
                    name: valitem,
                    value: fcitem.columnKey + '->' + valitem,
                    parentValue: fcitem.columnKey
                });
            });
            parents.push({
                name: fcitem.columnDescription,
                value: fcitem.columnKey
            });
        }
    });
    return {
        groups: parents,
        filters: groupFilters
    };
}

function fixWhereCondition(wherecondition) {
    for (var i = 0; i < wherecondition.length; i++) {
        var group = wherecondition[i];
        group.conditions = _.map(group.conditions, lowerCaseCondition);
    }
    return wherecondition;
}

function lowerCaseCondition(condition) {
    condition.selectedLhs = _.toLower(condition.selectedLhs);
    return condition;
}

function isTable(options) {
    return options.type === 'Table';
}

/**
 * Returns the prefix part of a column key.
 *
 * @param columnKey columnKey Column key (e.g. "fctactiveendpoint.dimendpointsid")
 * @returns string Substring before the '.' delimiter (e.g. "fctactiveendpoint")
 */
function getColumnKeyPrefix(columnKey) {
    if(_.startsWith(columnKey, 'query.') || _.startsWith(columnKey, 'query2')) { //UI-1214
        return columnKey;
    }
    return _.isString(columnKey) ? columnKey.split('.')[0] : '';
}

function getName(list, selected, idcol, namecol) {
    var names = _.filter(list, [idcol, selected]);
    return names.length > 0 ? names[0][namecol] : '';
}

export default { template: templateMarkup, viewModel: FlexiPanelOptions };
